import React from 'react';
import '../../components/style.css';
import Image from '../../pics';
import { Link } from 'react-router-dom';

function banner() {
  return (
    <div className=''>
        <div className='banner-sect uk-padding-large-top'>
            <div className="uk-container">
                <div className="uk-child-width-1-2@m uk-grid-small uk-grid-match align-items-center" data-uk-grid>
                    <div>
                        <div className="">
                            <h2 className="uk-text-left text-primary">
                                SECURE, FAST & RELIABLE
                            </h2>
                            <p className='uk-text-left text-secondary uk-text-justify'>
                                Choose faster deliveries with STRATOS – where velocity combines with security and reliability. trust our experienced courier professionals with over a decade of expertise in the delivery. STRATOS is into the business of integrated, logistics and distributions of shipments across India and World wide.
                            </p>
                            <div className="uk-text-left">
                                <Link to="/contact" className="uk-text-capitalize">
                                    <button>
                                        Book Now
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="uk-card">
                            <img src={Image.BANNER_IMAGE} alt="banner-image"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default banner